import { render, staticRenderFns } from "./cordx-one-step-hcg-pregnancy-test-cassette_h5.vue?vue&type=template&id=3fa198c3&scoped=true&"
import script from "./cordx-one-step-hcg-pregnancy-test-cassette_h5.vue?vue&type=script&lang=js&"
export * from "./cordx-one-step-hcg-pregnancy-test-cassette_h5.vue?vue&type=script&lang=js&"
import style0 from "./cordx-one-step-hcg-pregnancy-test-cassette_h5.vue?vue&type=style&index=0&id=3fa198c3&scoped=true&lang=less&"
import style1 from "./cordx-one-step-hcg-pregnancy-test-cassette_h5.vue?vue&type=style&index=1&id=3fa198c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa198c3",
  null
  
)

export default component.exports